var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretLeft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7083 25.2921C20.8012 25.385 20.8749 25.4953 20.9252 25.6167C20.9755 25.7381 21.0013 25.8682 21.0013 25.9996C21.0013 26.131 20.9755 26.2611 20.9252 26.3825C20.8749 26.5039 20.8012 26.6142 20.7083 26.7071C20.6154 26.8 20.5051 26.8737 20.3837 26.924C20.2623 26.9743 20.1322 27.0001 20.0008 27.0001C19.8694 27.0001 19.7393 26.9743 19.6179 26.924C19.4965 26.8737 19.3862 26.8 19.2933 26.7071L9.29329 16.7071C9.20031 16.6142 9.12655 16.5039 9.07623 16.3825C9.0259 16.2611 9 16.131 9 15.9996C9 15.8682 9.0259 15.738 9.07623 15.6166C9.12655 15.4952 9.20031 15.385 9.29329 15.2921L19.2933 5.29208C19.4809 5.10444 19.7354 4.99902 20.0008 4.99902C20.2662 4.99902 20.5206 5.10444 20.7083 5.29208C20.8959 5.47972 21.0013 5.73422 21.0013 5.99958C21.0013 6.26494 20.8959 6.51944 20.7083 6.70708L11.4145 15.9996L20.7083 25.2921Z",
    fill: "#161616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/CaretLeft.7063635e4aeb0ba1e4574cab47fe0e4b.svg";
export { ForwardRef as ReactComponent };